var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BlogForm',{attrs:{"token":_vm.token,"blogId":_vm.blog?.id}})
}
var staticRenderFns = []

export { render, staticRenderFns }